module.exports = __webpack_public_path__ + "static/media/r325.1ee7cf69.jpg";